import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import plans from "./data/data";
import Usages from "./Usages";
import History from "./History";
import getUsages from "./apis/getUsages";
import Card from "./Card";

function Billing({ setActiveOption }) {
  const user = useSelector((state) => state.user.user);
  const [usages, setUsages] = useState({
    current_plan: "Free",
    total_credits: 20,
    credits_limit: 0,
    create_expire: new Date(),
  });
  const [billHistory, setBillHistory] = useState([]);
  useEffect(() => {
    const fetchUsages = async () => {
      try {
        const res = await getUsages(user?.userId);
        setUsages(res.data);
        setBillHistory(res.paymentHistory);
      } catch (error) {
        console.error("Failed to fetch usages:", error);
      }
    };

    if (user?.userId) {
      fetchUsages();
    }
  }, [user?.userId]);
  return (
    <div className="w-full">
      <div className="flex flex-col gap-3">
        <h3 className="font-semibold text-xl 2xl:text-[1.3vw] 2xl:leading-[1.3vw]">
          Subscription Details
        </h3>
        <div className="w-full  p-5 rounded-xl bg-gradient-to-br from-stone-800 to-black  shadow-md shadow-gray-700 mt-3">
          <Card
            plan={
              plans.filter(
                (ele) =>
                  ele?.name.toLowerCase() === user?.plan?.type.toLowerCase()
              )[0]
            }
            selectmonth={"1"}
          />
          <div className="w-full flex justify-end mt-3">
            <button
              onClick={() => setActiveOption("plans")}
              className="w-fit px-3 text-white hover:bg-primary hover:shadow-none  transition-all ease-in duration-600  px-5 py-3 rounded-lg shadow-md shadow-stone-800  ">
              Manage Subscriptions
            </button>
          </div>
        </div>
        <Usages usages={usages} />
        <div className="w-full flex text-slate-600 flex-col p-5 gap-1 rounded-lg bg-white 2xl:text-[1.1vw] 2xl:leading-[1.1vw]">
          <h6 className="font-semibold text-black text-xl 2xl:text-[1.3vw] 2xl:leading-[1.3vw] min-[1500px]-text-2xl ">
            Billing Email
          </h6>
          <div className="text-sm 2xl:text-[1.1vw] 2xl:leading-[1.1vw] ">
            By default, all invoices will be sent to the email address of the
            team's creator. If you prefer to use a different email address for
            receiving invoices, please enter it here.
          </div>
          <div className="p-2 border border-1 border-slate-50 rounded-lg mt-2 px-5 italic bg-slate-200">
            {user?.email}
          </div>
        </div>
        <History billHistory={billHistory} email={user?.email} />
      </div>
    </div>
  );
}

export default Billing;
